// pages/confirm/EmailChangeValidation.jsx

import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function EmailChangeValidation() {
    const location = useLocation();
    const [message, setMessage] = useState('');
    const [token, setToken] = useState('');
    const { t } = useTranslation();

    useEffect(() => {
        // Retrieve the token from the URL path
        const urlToken = window.location.pathname.split('/emailchange/')[1];
        setToken(urlToken);
    
        // Validate the token by sending a request to the backend
        if (urlToken) {
            fetch(`/api/email/validate-change/${urlToken}`, {
                method: 'POST', // <-- Ajoutez cette ligne
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(response => response.json())
                .then(data => {
                    switch (data.status) {
                        case 'success':
                            setMessage(t('EmailChangeSuccess').split('\n'));
                            break;
                        case 'expired':
                            setMessage(t('EmailChangeExpired').split('\n'));
                            break;
                        case 'invalid':
                            setMessage(t('EmailChangeInvalid').split('\n'));
                            break;
                        default:
                            setMessage(t('EmailChangeDefault').split('\n'));
                    }
                })
                .catch(error => {
                    console.error('Error validating token:', error);
                    setMessage(t('EmailChangeError').split('\n'));
                });
        } else {
            console.error('Token not found in the URL');
            setMessage(t('EmailChangeError').split('\n'));
        }
    }, [location, t]);

    return (
        <div className='confirm-container'>
            {Array.isArray(message) 
                ? message.map((line, idx) => <p key={idx} className="custom-confirm">{line}</p>)
                : <p className="custom-confirm">{message}</p>
            }
        </div>
    );
}

export default EmailChangeValidation;

